import i18n from '@/plugins/i18n.js';
import storageHelpers from '@satellite/helpers/storage';
import gateFeedService from '@satellite/services/gate-feed-service';

export const OBSERVATIONS_MOCK = [
  {
    id: '0e5f6665-accc-412d-b9db-1609786065dd',
    direction: 'Inbound',
    images: [
      'https://observations.opendock.com/prod/0058/250529/165715/0/01748537_835484264960.jpg'
    ],
    checkin: false,
    detectedAt: '2025-05-18T17:02:55.055Z',
    vehicle: {
      class: '2A',
      detectedAt: '2025-05-18T17:02:55.055Z',
      damage: false,
      number: '123456789',
      dotNumber: 'DOT123',
      licensePlate: 'LP123',
      dwellTime: '2hrs 30mins',
      carrier: 'Test Carrier',
      fuelType: 'Diesel'
    },
    trailer: {
      id: '62181edf-db3b-4d5f-b085-0ee942e4fa49',
      vehicleObservationId: '0e5f6665-accc-412d-b9db-1609786065dd',
      direction: 'Inbound',
      licensePlate: 'LP-999222',
      damage: null,
      detectedAt: '2025-05-22T17:02:55.055Z',
      dwellTime: '2hrs 30mins',
      hasSeal: false,
      assetType: 'ContainerReefer'
    },
    chassis: {
      id: '3843e8a6-628c-4059-b3e0-6b3831777558',
      vehicleObservationId: '0e5f6665-accc-412d-b9db-1609786065dd',
      direction: 'Inbound',
      images: null,
      licensePlate: 'LP-123456',
      damage: true,
      detectedAt: '2025-05-22T17:02:55.055Z',
      dwellTime: '2hrs 30mins',
      assetType: 'Chassis',
      number: 'CH-123456'
    },
    gate: {
      id: '3d016b29-0b76-4143-b814-a8e6d7e1770e',
      name: 'Nice Site',
      site: {
        id: '01784863-1c50-4f4b-814c-478b4384a857',
        name: 'NIce Site',
        warehouseId: '3c095f61-d749-4a87-b073-7d7ebe10c9db'
      }
    }
  },
  {
    id: '0e5f6665-accc-412d-b9db-1609786065dd',
    direction: 'Outbound',
    images: [
      'https://observations.opendock.com/prod/0057/250529/213934/0/01748554_774597636096.jpg'
    ],
    checkin: true,
    detectedAt: '2025-05-18T17:02:55.055Z',
    vehicle: {
      class: '8',
      detectedAt: '2025-05-18T17:02:55.055Z',
      damage: false,
      number: '987654321',
      carrier: null,
      dotNumber: 'DOT123',
      licensePlate: 'LP123',
      dwellTime: '2hrs 30mins',
      fuelType: 'Diesel'
    },
    trailer: {
      id: '62181edf-db3b-4d5f-b085-0ee942e4fa49',
      vehicleObservationId: '0e5f6665-accc-412d-b9db-1609786065dd',
      direction: 'Inbound',
      licensePlate: 'LP-455689',
      damage: null,
      detectedAt: '2025-05-22T17:02:55.055Z',
      dwellTime: '2hrs 30mins',
      hasSeal: false,
      assetType: 'Dry Van'
    },
    chassis: {
      id: '3843e8a6-628c-4059-b3e0-6b3831777558',
      vehicleObservationId: '0e5f6665-accc-412d-b9db-1609786065dd',
      direction: 'Inbound',
      images: null,
      licensePlate: null,
      damage: true,
      detectedAt: '2025-05-22T17:02:55.055Z',
      dwellTime: '2hrs 30mins',
      assetType: 'Chassis',
      number: 'CH-654321'
    },
    gate: {
      id: '3d016b29-0b76-4143-b814-a8e6d7e1770e',
      name: 'Nice Site',
      site: {
        id: '01784863-1c50-4f4b-814c-478b4384a857',
        name: 'NIce Site',
        warehouseId: '3c095f61-d749-4a87-b073-7d7ebe10c9db'
      }
    }
  }
];

function makeInitialGateFeedData(state) {
  return {
    selectedWarehouseId: state.selectedWarehouse?.id ?? null
  };
}

function setGateFeedData(userId, key, data, state) {
  const novaGateFeedKey = storageHelpers.makeUserBoundedKey('nova_gate_feed', userId);

  if (!localStorage.getItem(novaGateFeedKey)) {
    localStorage.setItem(
      novaGateFeedKey,
      JSON.stringify({
        ...makeInitialGateFeedData(state)
      })
    );
  }

  let currentStorage = JSON.parse(localStorage.getItem(novaGateFeedKey));
  currentStorage[key] = data;

  localStorage.setItem(novaGateFeedKey, JSON.stringify({ ...currentStorage }));
}

const state = {
  selectedWarehouse: null,
  observations: [],
  isLoadingObservations: false
};

const getters = {};

const actions = {
  checkSelectedWarehouse({ state }) {
    if (!state.selectedWarehouse?.id) {
      this.notify(i18n.global.t('gateFeed.messages.pleaseSelectAWarehouseFirst'), 'error');
      return false;
    }

    return true;
  },
  persistSelectedWarehouse({ state, rootState }, warehouseId) {
    const userId = rootState.Auth.me.id;
    setGateFeedData(userId, 'selectedWarehouseId', warehouseId, state);
  },
  fetchPreviousGateFeedData({ rootState }) {
    const userId = rootState.Auth.me.id;
    const novaGateFeedKey = storageHelpers.makeUserBoundedKey('nova_gate_feed', userId);

    const data = localStorage.getItem(novaGateFeedKey);

    if (!data) {
      return null;
    }

    return JSON.parse(data);
  },
  async fetchObservations({ commit, state, dispatch }, params) {
    if (!dispatch('checkSelectedWarehouse')) {
      return;
    }
    commit('setIsLoadingObservations', true);
    try {
      const observations = await gateFeedService.getManyByWarehouseId(
        state.selectedWarehouse.id,
        params
      );
      commit('setObservations', observations || []);
    } catch (error) {
      this.notify('Failed to get observations', 'error');
      console.warn(error);
    } finally {
      commit('setIsLoadingObservations', false);
    }
  }
};

const mutations = {
  setSelectedWarehouse(state, warehouse) {
    state.selectedWarehouse = warehouse;
  },
  setIsLoadingObservations(state, value) {
    state.isLoadingObservations = value;
  },
  setObservations(state, observations) {
    state.observations = observations;
  }
};

export default {
  namespaced: true,
  name: 'GateFeed',
  state,
  getters,
  actions,
  mutations
};
